import { CreateScreenResponse } from '@api';
import { useQueries } from '@tanstack/react-query';
import { ActiveFilterOptions } from '@terminal/components/filters/Filters';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { getScreenerEntitiesTagsQueryConfig } from '@terminal/widgets/scenario/hooks/use-screener-entities-tags/useScreenerEntitiesTags';
import { useMemo } from 'react';

export const QUERY_KEY_SCREENER_FILTERS_ENTITIES_TAGS =
  'QUERY_KEY_SCREENER_FILTERS_ENTITIES_TAGS';

const parseScreenerFilterOptionsQueries = (
  savedScreens: CreateScreenResponse[],
  isScreenerExclusionEnabled: boolean,
  screenerFilter?: ActiveFilterOptions
) => {
  if (!screenerFilter?.options?.length) {
    return [];
  }

  return screenerFilter.options.map(option => {
    const screen = savedScreens.find(
      screen => screen.id === option.value.screenerId
    );

    const filterOptionsMerged = Object.values(
      screen?.config.filterOptionGroups ?? {}
    ).flat();

    return getScreenerEntitiesTagsQueryConfig({
      filterOptions: filterOptionsMerged,
      isScreenerExclusionEnabled,
    });
  });
};

export const useParsedScreenerOptionsQueries = (
  savedScreens: CreateScreenResponse[],
  screenerFilter?: ActiveFilterOptions
) => {
  const isScreenerExclusionEnabled = useFlags(state =>
    state.getFeatureFlagState('PLATFORM-4767-screener-exclusion')
  );
  const queries = useMemo(
    () =>
      parseScreenerFilterOptionsQueries(
        savedScreens,
        isScreenerExclusionEnabled,
        screenerFilter
      ),
    [savedScreens, isScreenerExclusionEnabled, screenerFilter]
  );

  return useQueries({
    queries,
    combine: results => ({
      data: results.map(res => res.data?.entities ?? []),
      isLoading: results.some(result => result.isLoading),
      isFetched: results.every(result => result.isFetched),
    }),
  });
};
